import { ResponseData, EnrollmentResponse, requestStatus  } from "./connector";
import StaticConnector from "./static-connector";
import { FasttrackConnector, FullEnrollmentConnector } from "./appsync";
import { MockConnector } from "./mock";
import APIConnector from "./connector";

export { FasttrackConnector, FullEnrollmentConnector, MockConnector, requestStatus, StaticConnector };
export type { EnrollmentResponse, ResponseData };
export default APIConnector;
